(() => {
 'use strict';
 const dialog=document.getElementById('catalogue-dialog');
 if(!dialog)return;
 const stage=dialog.querySelector('[data-catalogue-stage]'),template=dialog.querySelector('[data-catalogue-template]');
 const prev=dialog.querySelector('[data-catalogue-prev]'),next=dialog.querySelector('[data-catalogue-next]'),select=dialog.querySelector('[data-catalogue-select]');
 const enlarge=dialog.querySelector('[data-catalogue-enlarge]'),zoom=dialog.querySelector('[data-catalogue-zoom]'),loading=dialog.querySelector('[data-catalogue-loading]');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let book,host=dialog.querySelector('[data-catalogue-book]'),pages=[],index=0,focusIndex=0,requestedIndex=null,zoomIndex=0,trigger,libraryPromise,resizeTimer,lastSize='',opening=false,fallback=false;
 let pausedVideos=[];
 const total=18;
 function loadLibrary(){
  if(window.St?.PageFlip)return Promise.resolve();
  if(!libraryPromise)libraryPromise=new Promise((resolve,reject)=>{
   const script=document.createElement('script');script.src=dialog.dataset.flipLibrary;script.async=true;
   script.onload=()=>window.St?.PageFlip?resolve():reject(new Error('PageFlip unavailable'));
   script.onerror=()=>{script.remove();libraryPromise=null;reject(new Error('PageFlip unavailable'));};document.head.append(script);
  });
  return libraryPromise;
 }
 function loadImages(root){root.querySelectorAll('[data-catalogue-image]').forEach(img=>{if(!img.hasAttribute('src'))img.src=img.dataset.src;});}
 function isZoomed(){return dialog.classList.contains('is-enlarged');}
 function sync(){
  const current=isZoomed()?zoomIndex:focusIndex;
  select.value=String(current);prev.disabled=current===0;next.disabled=current>=total-1;
  dialog.querySelector('[data-catalogue-status]').textContent=`Seite ${current+1} von ${total}`;
  const spread=!fallback&&book?.getOrientation()==='landscape'&&index>0&&index<total-1;
  const landscape=!fallback&&book?.getOrientation()==='landscape';
  host.style.transform=landscape&&index===0?'translateX(-25%)':landscape&&index===total-1?'translateX(25%)':'';
  pages.forEach((page,i)=>{
   const visible=i===index||(spread&&i===index+1);
   page.inert=!visible;page.setAttribute('aria-hidden',String(!visible));
   if(fallback)page.hidden=!visible;
   if(Math.abs(i-index)<=3)loadImages(page);
  });
 }
 function renderZoom(){
  const page=template.content.querySelector(`[data-page="${zoomIndex}"]`).cloneNode(true);
  page.removeAttribute('aria-hidden');page.inert=false;zoom.replaceChildren(page);loadImages(zoom);zoom.scrollTop=0;zoom.scrollLeft=0;sync();
 }
 function setZoom(open){
  if(open){zoomIndex=focusIndex;dialog.classList.add('is-enlarged');zoom.hidden=false;host.inert=true;renderZoom();}
  else {dialog.classList.remove('is-enlarged');zoom.hidden=true;zoom.replaceChildren();host.inert=false;go(zoomIndex,false);}
  enlarge.setAttribute('aria-pressed',String(open));enlarge.setAttribute('aria-label',open?'Vergrößerung schließen':'Katalogseite vergrößern');
  enlarge.querySelector('span').textContent=open?'Verkleinern':'Vergrößern';
 }
 function go(target,animate=true){
  target=Math.max(0,Math.min(total-1,target));
  if(isZoomed()){zoomIndex=target;renderZoom();return;}
  if(fallback){index=target;focusIndex=target;sync();return;}
  if(!book)return;
  focusIndex=target;requestedIndex=target;
  pages.slice(Math.max(0,target-1),target+3).forEach(loadImages);
  if(reduced.matches||!animate)book.turnToPage(target);else book.flip(target,'bottom');
 }
 function step(direction){
  if(isZoomed()||fallback){go((isZoomed()?zoomIndex:index)+direction);return;}
  if(!book||book.getState()!=='read')return;
  if(reduced.matches){direction>0?book.turnToNextPage():book.turnToPrevPage();}
  else {direction>0?book.flipNext('bottom'):book.flipPrev('bottom');}
 }
 function build(){
  if(!dialog.open)return;
  if(book){index=book.getCurrentPageIndex();book.destroy();book=null;}
  host?.remove();host=document.createElement('div');host.className='catalogue-book';host.dataset.catalogueBook='';stage.prepend(host);
  const w=Math.max(100,stage.clientWidth-32),h=Math.max(100,stage.clientHeight-28),portrait=w<740;
  const pageWidth=Math.floor(Math.min(h*420/594,portrait?w:w/2,520)),pageHeight=Math.round(pageWidth*594/420);
  host.style.width=(portrait?pageWidth:pageWidth*2)+'px';host.style.height=pageHeight+'px';
  host.append(template.content.cloneNode(true));pages=[...host.querySelectorAll('.catalogue-page')];
  stage.style.setProperty('--book-unit',pageWidth/420+'px');
  fallback=!window.St?.PageFlip;
  if(fallback){host.classList.add('is-fallback');sync();}
  else {
   book=new window.St.PageFlip(host,{width:pageWidth,height:pageHeight,size:'fixed',usePortrait:true,autoSize:false,showCover:true,drawShadow:true,maxShadowOpacity:.28,flippingTime:reduced.matches?1:680,startPage:focusIndex,mobileScrollSupport:true,swipeDistance:24,clickEventForward:true,showPageCorners:!reduced.matches,disableFlipByClick:false});
   book.on('flip',e=>{index=e.data;focusIndex=requestedIndex!==null&&(requestedIndex===index||requestedIndex===index+1)?requestedIndex:index;requestedIndex=null;sync();});book.on('changeOrientation',()=>sync());
   requestedIndex=focusIndex;book.loadFromHTML(pages);index=book.getCurrentPageIndex();sync();
  }
  loading.hidden=true;lastSize=stage.clientWidth+'x'+stage.clientHeight;
  if(isZoomed()){host.inert=true;renderZoom();}
 }
 async function open(opener){
  if(dialog.open||opening)return;
  opening=true;trigger=opener;dialog.showModal();loading.hidden=true;
  dialog.querySelector('[data-catalogue-close]').focus();
  pausedVideos=[...document.querySelectorAll('video')].filter(v=>!v.paused);pausedVideos.forEach(v=>v.pause());
  if(!book&&!fallback){loading.hidden=false;try{await loadLibrary();}catch{fallback=true;dialog.querySelector('[data-catalogue-hint]').textContent='Mit den Pfeilen durch den Katalog blättern.';}}
  if(dialog.open)build();opening=false;
 }
 document.addEventListener('click',event=>{const opener=event.target.closest('[data-open-catalogue]');if(opener){event.preventDefault();open(opener);}});
 dialog.querySelector('[data-catalogue-close]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('close',()=>{
  clearTimeout(resizeTimer);if(book){index=book.getCurrentPageIndex();book.destroy();book=null;}else host.remove();pages=[];
  trigger?.focus({preventScroll:true});
  pausedVideos.forEach(v=>{const r=v.getBoundingClientRect();if(!reduced.matches&&r.bottom>0&&r.top<innerHeight)v.play().catch(()=>{});});pausedVideos=[];
 });
 dialog.addEventListener('cancel',event=>{if(isZoomed()){event.preventDefault();setZoom(false);enlarge.focus();}});
 dialog.addEventListener('click',event=>{const jump=event.target.closest('[data-catalogue-jump]');if(jump){event.preventDefault();event.stopPropagation();go(Number(jump.dataset.catalogueJump));}});
 // Keep links and chapter buttons usable without starting a page drag.
 ['pointerdown','mousedown','touchstart'].forEach(name=>dialog.addEventListener(name,event=>{if(event.target.closest('.catalogue-page a,.catalogue-page button'))event.stopPropagation();},true));
 prev.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));
 select.addEventListener('change',()=>go(Number(select.value)));enlarge.addEventListener('click',()=>setZoom(!isZoomed()));
 dialog.addEventListener('keydown',event=>{if(['SELECT','INPUT'].includes(event.target.tagName))return;if(event.key==='ArrowLeft'){event.preventDefault();step(-1);}if(event.key==='ArrowRight'){event.preventDefault();step(1);}});
 new ResizeObserver(()=>{if(!dialog.open||opening||!pages.length)return;const size=stage.clientWidth+'x'+stage.clientHeight;if(size===lastSize)return;clearTimeout(resizeTimer);resizeTimer=setTimeout(build,150);}).observe(stage);
 reduced.addEventListener('change',()=>{if(dialog.open)build();});
})();
